import { preprocessApiException } from '@/scripts/utils/api';
import { formatDate, getThumbnail, makeSrcset } from '@/scripts/utils/cms';
import { chunk } from '@/scripts/utils/base';
import microTemplate from '@/scripts/lib/microTmpl';
import AjaxList from '@/components/AjaxList';

import resultsTemplate from '../templates/results-list.html';

/**  @extends {AjaxList<Post>} */
export default class SearchList extends AjaxList {
   _searchFields = [
      'title', 'excerpt', 'content',
      'post_category.name',
      'post_tags.tag_id.name',
      'post_author.first_name',
      'post_author.last_name',
   ];

   _renderFields = [
      'slug', 'title', 'excerpt',
      'type', 'published_on', 'status',
      'post_category.*',
      'post_author.*',
      'main_image.data.*',
   ];

   query = '';

   formatDate = formatDate;
   getThumbnail = getThumbnail;
   makeSrcset = makeSrcset;

   init(...args) {
      super.init(...args);
      this._getElements();
   }

   _initEvents(...args) {
      super._initEvents(...args);

      this.events.addListener('request.processed', () => {
         requestAnimationFrame(() => this._updateTotal());
      });
   }

   renderCurPage() {
      this.$list.innerHTML = microTemplate(resultsTemplate, this);
   }

   async _makeRequest(signal) {
      const { data, meta } = await this._fetchPage(signal);

      return {
         total: meta.filter_count,
         items: data.filter(p => p.status === 'published'),
      };
   }

   async _processRequest(...args) {
      await super._processRequest(...args);
      this._numberOfItems = this.pageItems.length;
      this._allData = chunk(this.pageItems, this._pageSize);
   }

   _showError(message) {
      this.$error.innerHTML = message;
   }

   /** @returns {Promise<DirectusResponse<Post[]>>} */
   async _fetchPage(signal) {
      try {
         const resp = await fetch(this._buildUrl(this.page), { signal });
         if (!resp.ok) throw resp;
         return resp.json();
      } catch (e) {
         await preprocessApiException(e);
      }
   }

   _buildUrl() {
      const url = new URL(`${process.env.API}/items/posts`);
      url.searchParams.set('meta', 'filter_count');
      url.searchParams.set('fields', this._renderFields.join(','));
      // url.searchParams.set('offset', this._itemsOffset);
      // url.searchParams.set('limit', this._pageSize);

      this._searchFields.forEach((field) => {
         url.searchParams.set(`filter[${field}][like]`, this.query);
         url.searchParams.set(`filter[${field}][logical]`, 'or');
      });

      return url;
   }

   _updateTotal() {
      this.$total.innerHTML = this._numberOfItems;
   }

   _getElements() {
      this.$list = this.$root.querySelector('.results-list-js');
      this.$total = this.$root.querySelector('.total-js');
      this.$error = this.$root.querySelector('.error-js');
   }
}